import React from 'react'
import loadingImage from '@assets/bonus-system/loading-spinner.svg'

const Loader: React.FC = () => {
    return (
        <div className="fixed inset-0 z-[102] flex justify-center bg-black opacity-50">
            <img
                src={loadingImage}
                alt="Loader image"
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-9999999 w-64 h-64"
            />
        </div>
    )
}

export default Loader
